export const BASE_URL = `http://test.appraiser-assistant.com:5000/api`;
// export const BASE_URL = `https://nplpfho4ml.execute-api.ap-south-1.amazonaws.com/api`;
// export const BASE_URL = ` http://192.168.1.51:5000/api`;

// 1 Car Information by Vin Number API
export const API_URL_CAR_INFO_BY_VIN_NUMBER = `/car/carinfoByVin`;
export const API_URL_CAR_INFO_VIN = `/car/carInfo`;
export const API_URL_MARKET_VALUE_PRICE = `/car/marketValuebyVin`;
// api:- http://192.168.1.37:5000/api/car/carinfoByVin/5TDYK3DC8FS560664

// 2 Car Listing API
export const API_URL_CAR_LISTING = `/car/carListing`;
// api:- http://192.168.1.64:5000/api/car/carListing?year_max=2020&price_max=60000

// 3 Sale History API
export const API_URL_SALE_HISTORY = `/car/saleHistory`;
// api:- http://192.168.1.56:5000/api/car/saleHistory/5TDYK3DC8FS560664

// 4 Auction API
export const API_URL_AUCTION = `/car/auction`;
// api:- http://localhost:5000/api/car/auction/5TDYK3DC8FS560664

// 5. Market value on the basis of Year, car model
export const API_URL_MARKET_VALUE = `/car/marketValuebyYearAndModel`;
// api:- http://localhost:5000/api/car/marketValuebyYearAndModel?year=2022&make=Tesla&model=Model 3&state=2022&mileage_value=12000

// 6. Get Cars by body style, price or year
export const API_URL_BODY_TYPE_FILTERATION = `/car/bodyTypeFilteration`;
// api:- http://192.168.1.64:5000/api/car/bodyTypeFilteration/suv
export const API_URL_PRICE_FILTERATION = `/car/priceFilteration`;
// api:- http://192.168.1.64:5000/api/car/priceFilteration/page
export const API_URL_YEAR_FILTERATION = `/car/yearFilteration`;
// api:- http://192.168.1.64:5000/api/car/yearFilteration/page

export const API_URL_PREMIUM_VIN_DECODE=`/premiumVinDecode`
export const API_URL_GENERATE_PDF = `/car/generatePdf`;
export const API_URL_Compare_GENERATE_PDF = `/car/generateFreetrialPdf`;
export const API_URL_SIGNIN = `/user/login`;
export const API_URL_SIGNUP = `/user/register`;
export const API_SALVAGE_LIST = `/car/salvagevaluecarlistings`;
export const API_SALVAGE_PDF = `/car/finalSalvageReeport`;